import React, { useState, useEffect, useContext } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Col, Drawer, Form, Input, Row, Table } from 'antd';
import { useInput } from '../../../../../shared/hooks/useInput';
import { ApiApartmentQueuesService } from '../../../../../shared/api/apartment/queues/queues.service';
import { ApiApartmentQueueService } from '../../../../../shared/api/apartment/queue/queue.service';
import { useDrawerVisibility } from '../../../../../shared/hooks/useDrawerVisibility';
import { TableActionColumn } from '../../components/TableActionColumn/TableActionColumn';
import { countText, SectionToolbar, useSectionSearch } from '../../components/SectionToolbar/SectionToolbar';
import { useCanEdit } from '../../../sectionAccess';
import { Context } from '../../../../../shared/context/context';

const columns = [
  { title: 'ID очереди', dataIndex: 'id', width: 120 },
  { title: 'Название', dataIndex: 'name' },
  { title: 'ID ЖК (старый)', dataIndex: 'apartmentResidentialComplexId', width: 160 },
  {
    title: 'Действия',
    width: 240,
    render: (row) => (
      <TableActionColumn
        onDeleteButtonClick={() => ApiApartmentQueueService.deleteQueue(row.id)}
        payloadOfFieldWhichWillBeUpdated={{ queueIdWhichWillBeUpdated: row.id }}
      />
    ),
  },
];

export const QueueSection = () => {
  const canEdit = useCanEdit();
  const [newQueueInputValue, handleNewQueueInputValueChange] = useInput('');
  const [residentialComplexIdInputValue, handleResidentialComplexIdInputValueChange] = useInput('');
  const [setDrawerVisibility] = useDrawerVisibility();
  const { state, dispatch } = useContext(Context);
  const [tableData, setTableData] = useState([]);
  const [search, setSearch, queues] = useSectionSearch(tableData, ['name', 'id', 'apartmentResidentialComplexId']);

  const submitNewQueue = () => {
    if (newQueueInputValue.trim() && residentialComplexIdInputValue.trim()) {
      ApiApartmentQueueService.createQueue(newQueueInputValue, residentialComplexIdInputValue);

      ApiApartmentQueuesService.fetchAllQueues().then((response) => {
        const queues = response.data;

        queues.forEach((queue) => (queue.key = queue.id));

        setTableData(queues);
      });

      setDrawerVisibility({ queueDrawerVisibility: false });
      dispatch({ type: 'emptyAdminInput' });
    }
  };

  useEffect(() => {
    ApiApartmentQueuesService.fetchAllQueues().then((response) => {
      const queues = response.data;

      queues.forEach((queue) => (queue.key = queue.id));

      setTableData(queues);
    });
  }, []);

  return (
    <section className="queue-section">
      <Table
        title={() => (
          <SectionToolbar
            search={search}
            onSearch={setSearch}
            placeholder='Название очереди или ID'
            count={countText(tableData.length, queues.length, search)}
          >
            {canEdit && (
              <Button type="primary" icon={<PlusOutlined />} onClick={() => setDrawerVisibility({ queueDrawerVisibility: true })}>
                Добавить очередь
              </Button>
            )}
          </SectionToolbar>
        )}
        columns={canEdit ? columns : columns.slice(0, -1)}
        dataSource={queues}
        locale={{ emptyText: 'Ничего не нашлось' }}
      />
      <Drawer
        title="Новая очередь"
        width={720}
        onClose={() => setDrawerVisibility({ queueDrawerVisibility: false })}
        visible={state.queueDrawerVisibility}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: 'right',
            }}
          >
            <Button onClick={() => setDrawerVisibility({ queueDrawerVisibility: false })} style={{ marginRight: 8 }}>
              Отмена
            </Button>
            <Button onClick={submitNewQueue} type="primary">
              Добавить
            </Button>
          </div>
        }
      >
        <Form layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={24}>
              <Input
                onChange={handleNewQueueInputValueChange}
                placeholder="Название очереди"
                value={newQueueInputValue}
              />
              <Input
                onChange={handleResidentialComplexIdInputValueChange}
                placeholder="ID ЖК (старый)"
                value={residentialComplexIdInputValue}
              />
            </Col>
          </Row>
        </Form>
      </Drawer>
    </section>
  );
};
